module.exports = __webpack_public_path__ + "static/media/GenericPhone.f21ebfe9.png";